module.exports = __webpack_public_path__ + "img/cog.cec55775.svg";